import { get } from 'lodash'
import { Observable } from 'rxjs'
import intl from 'react-intl-universal'
import { ACTION_GO_TO_LIVE_STORY } from '~/redux/appReducer'
import { errorAction } from '~/redux/commonActions'
import { siteServiceBasePaths } from '~/redux/settingsReducer'
import { getCirculation as getCirculations } from '~/redux/storyData'

export default (action$, store, { serviceResolver }) =>
  action$
    .ofType(ACTION_GO_TO_LIVE_STORY)
    .mergeMap(() => {
      const storyService = serviceResolver('storyService')
      return Observable.from(storyService.getStory()).map((story) => {
        const basePaths = siteServiceBasePaths(store.getState())
        if (!basePaths || basePaths.length === 0) {
          return new Error(
            intl.get('epics.goToLiveStoryEpic.errors.noBasePaths', {
              appName: 'Composer',
            })
          )
        }
        const defaultWebsite = basePaths.find((config) => config.default)
        if (!defaultWebsite) {
          return new Error(
            intl.get('epics.goToLiveStoryEpic.errors.noDefaultSite', {
              appName: 'Composer',
            })
          )
        }

        let websiteId = get(story, ['canonical_website'])
        if (!websiteId && defaultWebsite) {
          websiteId = defaultWebsite.id
        }
        const matchingWebsite = basePaths.find(
          (config) => config.id === websiteId
        )
        const { path: websitePath } = matchingWebsite || defaultWebsite

        if (!matchingWebsite) {
          websiteId = defaultWebsite.id
        }

        let storyPath
        const circulations = getCirculations(store.getState())
        const matchingCirculation = circulations.find(
          (circulation) => circulation.website_id === websiteId
        )
        if (matchingCirculation) {
          storyPath = matchingCirculation.website_url
        }

        if (!storyPath) {
          return new Error(
            intl.get('epics.goToLiveStoryEpic.errors.noWebsiteUrl', {
              websiteId,
            })
          )
        }

        window.open(websitePath + storyPath, '_blank')
      })
    })
    .filter((action) => action instanceof Error)
    .map((error) => errorAction(error))
